(() => {
  const HOME_PATHS = ['/', ''];
  const TARGET_RATING_COLLECTIONS = new Set([
    '/collections/starter-sets',
    '/collections/rompers-jumpsuits',
    '/collections/bodysuits-rompers'
  ]);

  function isHome() {
    return HOME_PATHS.includes(window.location.pathname.replace(/\/+$/, '') || '/');
  }

  function createHomeLink(className) {
    const link = document.createElement('a');
    link.href = '/';
    link.textContent = 'Home';
    link.className = className + ' bnb-home-menu-link' + (isHome() ? ' is-active' : '');
    if (isHome()) link.setAttribute('aria-current', 'page');
    return link;
  }

  function ensureHomeNavigation(scope = document) {
    scope.querySelectorAll('.header__menu > ul').forEach((list) => {
      if (list.querySelector(':scope > .bnb-home-menu-item')) return;
      const item = document.createElement('li');
      item.className = 'bnb-home-menu-item';
      const link = createHomeLink('menu__item flex relative z-2 font-navigation');
      const label = document.createElement('span');
      label.className = 'reversed-link';
      label.textContent = 'Home';
      link.replaceChildren(label);
      item.appendChild(link);
      list.prepend(item);
    });

  }

  function normalizeStock(scope = document) {
    scope.querySelectorAll('.product__inventory').forEach((row) => {
      const text = row.querySelector('.product__inventory-text');
      if (!text) return;
      let desired = '';
      if (row.classList.contains('product__inventory--in-stock') || row.classList.contains('product__inventory--low-stock')) desired = 'In Stock';
      else if (row.classList.contains('product__inventory--out-of-stock')) desired = 'Out of Stock';
      if (desired && text.textContent.trim() !== desired) text.textContent = desired;
    });
  }

  function exposeSizing(scope = document) {
    scope.querySelectorAll('variant-selects .product-form__input').forEach((group) => {
      const label = group.querySelector('.form__label');
      if (!label || !label.textContent.toLowerCase().includes('size')) return;
      const chart = group.querySelector('.open-size-chart');
      if (chart && chart.textContent.trim() !== 'View Size Guide (CM)') chart.textContent = 'View Size Guide (CM)';
      group.querySelectorAll('.bnb-sizing-helper').forEach((helper) => helper.remove());
    });
  }

  function ensureRatingStyles() {
    if (document.getElementById('bnb-generated-rating-styles')) return;
    const style = document.createElement('style');
    style.id = 'bnb-generated-rating-styles';
    style.textContent = `
      .bnb-global-card .jdgm-prev-badge,
      body.product-template .jdgm-prev-badge { display: none !important; }
      .bnb-generated-rating { display:flex!important;align-items:center;gap:5px;width:max-content;margin:0 0 7px;color:#334155;font-size:11px;line-height:1; }
      .bnb-generated-rating--pdp { margin:6px 0 8px;font-size:13px; }
      .bnb-generated-rating__stars { position:relative;display:inline-block;font-size:14px;line-height:1;letter-spacing:2px;white-space:nowrap; }
      .bnb-generated-rating--pdp .bnb-generated-rating__stars { font-size:18px; }
      .bnb-generated-rating__base { color:#d7dde4; }
      .bnb-generated-rating__fill { position:absolute;top:0;left:0;overflow:hidden;color:#f5b301;white-space:nowrap; }
      .bnb-generated-rating__value { color:#8f98a4;font-size:9px;font-weight:500;white-space:nowrap; }
      .bnb-generated-rating--pdp .bnb-generated-rating__value { font-size:10px; }
      @media (max-width:767px) {
        .bnb-generated-rating { gap:4px;margin-bottom:4px;font-size:10px; }
        .bnb-generated-rating__stars { font-size:11px;letter-spacing:1px; }
        .bnb-generated-rating--pdp { gap:5px;margin:7px 0 8px;font-size:12px; }
        .bnb-generated-rating--pdp .bnb-generated-rating__stars { font-size:17px;letter-spacing:1.5px; }
        .bnb-generated-rating__value,.bnb-generated-rating--pdp .bnb-generated-rating__value { font-size:9px; }
      }
    `;
    document.head.appendChild(style);
  }

  function normalizePath() {
    return window.location.pathname.replace(/\/+$/, '') || '/';
  }

  function productHandleFromCard(card) {
    const raw = card?.dataset?.bnbCardUrl || card?.querySelector('a[href*="/products/"]')?.getAttribute('href') || '';
    if (!raw) return '';
    try {
      const match = new URL(raw, window.location.origin).pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch {
      return '';
    }
  }

  function scoreFromHandle(handle) {
    let hash = 2166136261;
    for (let i = 0; i < handle.length; i += 1) {
      hash ^= handle.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return (37 + ((hash >>> 0) % 14)) / 10;
  }

  function buildRating(handle, context) {
    const score = scoreFromHandle(handle);
    const row = document.createElement('div');
    row.className = `bnb-generated-rating bnb-generated-rating--${context}`;
    row.setAttribute('aria-label', `${score.toFixed(1)} out of 5 stars`);
    row.innerHTML = `<span class="bnb-generated-rating__stars" aria-hidden="true"><span class="bnb-generated-rating__base">★★★★★</span><span class="bnb-generated-rating__fill" style="width:${score * 20}%">★★★★★</span></span><span class="bnb-generated-rating__value">(${score.toFixed(1)})</span>`;
    return row;
  }

  function applyRatings(scope = document) {
    ensureRatingStyles();

    scope.querySelectorAll?.('.bnb-global-card').forEach((card) => {
      const generated = card.querySelector('.bnb-generated-rating--card');
      const storedRating = card.querySelector('.bnb-global-card__rating:not(.bnb-generated-rating)');
      const isEligible = card.dataset.bnbGeneratedRating === 'true';

      if (storedRating || !isEligible) {
        generated?.remove();
        return;
      }

      if (generated) return;
      const handle = productHandleFromCard(card);
      const slot = card.querySelector('.bnb-global-card__rating-slot');
      if (handle && slot) slot.appendChild(buildRating(handle, 'card'));
    });

    if (!document.body?.classList.contains('product-template')) return;
    const config = window.FoxTheme?.bnbRating || {};
    const storedRating = document.querySelector('.bnb-proof:not(.bnb-generated-rating)');

    if (storedRating || !config.allowed || !config.productHandle) {
      document.querySelectorAll('.bnb-generated-rating--pdp').forEach((node) => node.remove());
      return;
    }

    if (document.querySelector('.bnb-generated-rating--pdp')) return;
    const title = scope.querySelector?.('.product__block--title') || document.querySelector('.product__block--title');
    if (title) title.insertAdjacentElement('afterend', buildRating(config.productHandle, 'pdp'));
  }

  function applyRequirements(scope = document) {
    ensureHomeNavigation(scope);
    normalizeStock(scope);
    exposeSizing(scope);
    applyRatings(scope);
  }

  let scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyRequirements(document);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => applyRequirements(document));
  else applyRequirements(document);

  document.addEventListener('shopify:section:load', (event) => applyRequirements(event.target));
  document.addEventListener('shopify:section:select', (event) => applyRequirements(event.target));
  new MutationObserver(scheduleApply).observe(document.documentElement, { childList: true, subtree: true });
})();

(() => {
  const legacyCodePattern = /^BNB-MULTI-\d+$/i;
  const pairCodePattern = /^BNB10-(\d+)-(\d+)$/i;
  const anyBnbCodePattern = /^(?:BNB-MULTI-\d+|BNB10-\d+-\d+)$/i;
  let syncing = false;

  const productIdOf = (item) => String(item?.product_id || item?.product?.id || '');

  const pairCodeForIds = (ids) => {
    const clean = Array.from(new Set((ids || []).map((id) => String(id).replace(/\D/g, '')).filter(Boolean)));
    if (clean.length !== 2) return '';
    clean.sort((a, b) => Number(a) - Number(b));
    return `BNB10-${clean[0]}-${clean[1]}`;
  };

  const desiredCodes = (cart) => {
    const bundles = new Map();
    const standaloneProductIds = new Set();

    (cart?.items || []).forEach((item) => {
      const properties = item.properties || {};
      const bundleId = String(properties._bnb_bundle_id || '');
      const productId = productIdOf(item);
      const quantity = Number(item.quantity || 0);

      if (!bundleId) {
        if (productId && quantity > 0) standaloneProductIds.add(productId);
        return;
      }

      const rawCode = String(properties._bnb_offer_code || '');
      const expected = Math.max(2, Number(properties._bnb_offer_quantity || 2));
      const percent = Number(properties._bnb_offer_percent || 0);
      if (!Number.isFinite(expected) || !Number.isFinite(percent) || quantity < 1 || !productId) return;

      const current = bundles.get(bundleId) || {
        rawCode,
        expected,
        percent,
        quantity: 0,
        productIds: new Set(),
        invalid: false,
      };

      if (current.rawCode !== rawCode || current.expected !== expected || current.percent !== percent) current.invalid = true;
      current.quantity += quantity;
      current.productIds.add(productId);
      bundles.set(bundleId, current);
    });

    const codes = [];
    bundles.forEach((bundle) => {
      if (bundle.invalid || bundle.quantity !== bundle.expected) return;

      let code = '';
      let entitledIds = [];

      if (bundle.expected === 2 && bundle.percent === 10 && bundle.productIds.size === 2) {
        entitledIds = Array.from(bundle.productIds);
        code = pairCodeForIds(entitledIds);
      } else if (anyBnbCodePattern.test(bundle.rawCode)) {
        code = bundle.rawCode;
        const match = code.match(pairCodePattern);
        if (match) entitledIds = [match[1], match[2]];
      }

      if (!code) return;
      if (entitledIds.some((id) => standaloneProductIds.has(String(id)))) return;
      codes.push(code);
    });

    return Array.from(new Set(codes)).sort();
  };

  const hasAppliedBnbDiscount = (cart) => {
    const matches = (value) => anyBnbCodePattern.test(String(value || ''));
    if ((cart?.cart_level_discount_applications || []).some((app) => matches(app?.title) || matches(app?.code))) return true;
    return (cart?.items || []).some((item) => {
      if ((item.discounts || []).some((discount) => matches(discount?.title) || matches(discount?.code))) return true;
      return (item.line_level_discount_allocations || []).some((allocation) => {
        const application = allocation?.discount_application || {};
        return matches(application.title) || matches(application.code);
      });
    });
  };

  const sync = async (cart, sections = [], sectionsUrl = window.location.pathname) => {
    if (syncing || !cart) return cart;
    const signature = desiredCodes(cart).join(',');
    syncing = true;

    try {
      const body = {
        discount: signature,
        attributes: { _bnb_discount_signature: signature },
      };
      if (sections.length) {
        body.sections = sections;
        body.sections_url = sectionsUrl;
      }

      const route = window.FoxTheme?.routes?.cart_update_url || '/cart/update.js';
      const response = await fetch(route, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify(body),
      });
      if (!response.ok) throw new Error('Unable to synchronize multi-buy discount');
      return await response.json();
    } catch (error) {
      console.error('[BNB multi-buy discount]', error);
      return cart;
    } finally {
      syncing = false;
    }
  };

  window.BnbMultiBuyDiscounts = { sync, desiredCodes };

  customElements.whenDefined('bnb-starter-group-offer').then(() => {
    const OfferClass = customElements.get('bnb-starter-group-offer');
    const proto = OfferClass?.prototype;
    if (!proto || proto.__bnbPairSyncPatched) return;
    proto.__bnbPairSyncPatched = true;

    const originalSyncDiscounts = proto.syncDiscounts;
    if (typeof originalSyncDiscounts !== 'function') return;

    proto.syncDiscounts = function(cart) {
      if (window.BnbMultiBuyDiscounts?.sync) {
        return window.BnbMultiBuyDiscounts.sync(cart);
      }
      return originalSyncDiscounts.call(this, cart);
    };
  });

  const initialSync = async () => {
    try {
      const cartUrl = window.FoxTheme?.routes?.cart_url || '/cart';
      const response = await fetch(`${cartUrl}.js`, {
        cache: 'no-store',
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return;

      const cart = await response.json();
      const signature = desiredCodes(cart).join(',');
      const activeSignature = cart.attributes?._bnb_discount_signature || '';
      const hadAppliedBnbDiscount = hasAppliedBnbDiscount(cart);
      const updatedCart = await sync(cart);
      const needsRefresh = signature !== activeSignature || (signature === '' && hadAppliedBnbDiscount);
      if (!needsRefresh) return;

      if (window.location.pathname === cartUrl) window.location.reload();
      else document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false, cart: updatedCart } }));
    } catch (error) {
      console.error('[BNB multi-buy initial sync]', error);
    }
  };

  const scheduleInitialSync = () => {
    if (!document.documentElement.classList.contains('cart-has-items')) return;
    const run = () => initialSync();
    if ('requestIdleCallback' in window) window.requestIdleCallback(run, { timeout: 2500 });
    else window.setTimeout(run, 1200);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleInitialSync, { once: true });
  else scheduleInitialSync();
})();
